<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2 14.5H15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M3.5 14.5V3.5H6.5V14.5" stroke="#E5E5E5" stroke-width="1.2" stroke-linecap="round"/>
  <rect x="4.1" y="5" width="1.8" height="7" rx="0.4" fill="#E5E5E5"/>
  <path d="M8.5 14.5V9.5H12.5V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
  <path d="M8.5 7.5H13.5V10.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
